import React, { useEffect, useState } from 'react';
import classes from "./LiveMatches.module.css";
import Layout from '../component/Layout';
import Header from '../component/Header';
import SubLayout from '../component/SubLayout';
import Container from '../component/Container';
import { liveMatchesApi, upcomingMatchesApi, userMatchesApi } from '../http/http';
import { useDispatch, useSelector } from 'react-redux';
import moment from "moment-timezone";
import { useNavigate } from 'react-router-dom';
import BottomNavbar from '../component/BottomNavbar';
import { FaCircle, FaMinus } from 'react-icons/fa6';
import MatchLayout from '../component/MatchLayouts/MatchLayout';
import MatchLiveLayout from '../component/MatchLayouts/MatchLiveLayout';
import SmallLoader from '../component/SmallLoader';
import { removeUserDetails } from '../store/slices/userSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const LiveMatches = () => {
    const [liveMatches, setLiveMatches] = useState([]);
    const [upcomingMatches, setUpcomingMatches] = useState([]);
    const { userDetails } = useSelector(state => state?.persisted?.userSlice);
    const [userMatches, setUserMatches] = useState(null);

    const [loader, setLoader] = useState(true);
    const [loading, setLoading] = useState(true);

    const dispatch = useDispatch();

    const navigate = useNavigate();

    const {t}=useTranslation();

    const fetchUserMatches = async () => {
        try {
            const response = await userMatchesApi(userDetails?.token);
            console.log(response, 'response...');
            setUserMatches({
                fantasy: response?.data?.fantasy,
                prediction: response?.data?.prediction
            })
        } catch (error) {
            console.log(error, 'error---');

            if (error?.response?.status == 403) {
                dispatch(removeUserDetails());
                toast.error(t("129"));
                navigate('/');
            }
            else {
                toast.error(error?.response?.data?.message || error?.response?.message || error?.data?.message || t("128"));
                console.log(error, 'error---');
            }
        }
    }

    const fetchLiveMatches = async () => {
        try {
            const response = await liveMatchesApi(userDetails?.token);
            console.log(response, 'response....');
            setLiveMatches(response?.data);
        } catch (error) {
            console.log(error, 'error--');
        }
    }

    const fetchUpcomingMatches = async () => {
        try {
            const response = await upcomingMatchesApi(userDetails?.token);
            setUpcomingMatches(response?.data);
            console.log(response, 'response...');
        }
        catch (error) {
            console.error("Error fetching upcoming matches:", error);
        }
    }

    const fetchData = async (load) => {
        if (load) {
            setLoading(true);
        }
        setLoader(true);
        await fetchUserMatches(load);
        await fetchLiveMatches(load);
        await fetchUpcomingMatches(load);
        setLoading(false);
        setLoader(false);
    }

    useEffect(() => {
        fetchData(true);
    }, []);

    useEffect(() => {
        if (!loader) {
            const intervalId = setInterval(() => {
                if (!document.hidden) {
                    fetchData(false);
                }
            }, 10000);
            return () => clearInterval(intervalId);
        }

    }, [loader]);

    return (
        <Layout>
            <SubLayout>
                <Header active={2} />

                <Container>

                    {loading ? <SmallLoader /> : (
                        <>
                            <div className={classes.title_container}>
                                <p className={classes.title}>{t("90")}</p>
                            </div>

                            <div className={classes.upcoming_matches_container}>
                                {liveMatches.length > 0 ?
                                    liveMatches.map((match, index) => {
                                        const match_details = JSON.parse(match?.match_details);
                                        console.log(match_details, 'md');
                                        return (
                                            <MatchLiveLayout match={match} match_details={match_details} key={index} />
                                        )
                                    }
                                    )
                                    : (
                                        <div className={classes.info_container}>
                                            <p className={classes.info}>
                                                {t("91")}
                                            </p>
                                        </div>
                                    )
                                }
                            </div>

                            <div className={classes.title_container}>
                                <p className={classes.title}>{t("105")}</p>
                            </div>

                            <div className={classes.upcoming_matches_container}>
                                {upcomingMatches.length > 0 &&
                                    upcomingMatches.map((match, index) => {
                                        return (
                                            <MatchLayout match={match} key={index} fantasy_match_joined={userMatches?.fantasy?.filter(data => data?.match_fixture_id == match?.match_fixture_id).length > 0}
                                                prediction_match_joined={userMatches?.prediction?.filter(data => data?.match_fixture_id == match?.match_fixture_id).length > 0}
                                            />
                                        )
                                    }

                                    )}
                            </div>

                        </>
                    )}

                </Container>
            </SubLayout>

            {/* <BottomNavbar active={2} /> */}
        </Layout>
    )
}

export default LiveMatches